import { normalizeCampaign } from './normalize-campaign'

export const normalizeLayoutCampaign = (rawData) => {
  const { z_order: zOrder = '0', campaign_list: campaignList = [] } = rawData
  return {
    zOrder,
    campaignList: campaignList?.map(normalizeCampaign)
  }
}
